// Shared timeago helper — Spanish, terse.
export function timeAgo(d) {
  if (!d) return "—";
  const diff = (Date.now() - new Date(d).getTime()) / 1000;
  if (diff < 60)    return "ahora";
  if (diff < 3600)  return `hace ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `hace ${Math.floor(diff / 3600)} h`;
  if (diff < 86400 * 30) return `hace ${Math.floor(diff / 86400)} días`;
  if (diff < 86400 * 365) return `hace ${Math.floor(diff / (86400 * 30))} meses`;
  return `hace ${Math.floor(diff / (86400 * 365))} años`;
}
